import { loaiThuChiApi } from "../../../api/category/loaiThuChiApi";
import { IDmLoaiThuChi } from "../../../model/respone/category/IDmLoaiThuChi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { rootActions } from "../../actions/rootActions";
import {
  eDmLoaiThuChiActionIds,
  IDmLoaiThuChiActionTypes,
} from "./../../action-types/category/IDmLoaiThuChiActions";
import { call, put, takeEvery, takeLatest } from "redux-saga/effects";

export function* loaiThuChiSaga(): any {
  yield takeLatest(eDmLoaiThuChiActionIds.LOAD_START, loadWorker);
  yield takeEvery(eDmLoaiThuChiActionIds.SAVE_START, saveWorker);
  yield takeEvery(eDmLoaiThuChiActionIds.DELETE_START, deleteWorker);
  yield takeEvery(eDmLoaiThuChiActionIds.DELETE_MANY_START, deleteManyWorker);
}

function* loadWorker(): any {
  const res: IBaseRespone = yield call(loaiThuChiApi.SelectAll);
  if (res.is_success) {
    yield put(rootActions.category.loaiThuChi.LOAD_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.category.loaiThuChi.LOAD_ERRR(res.message ?? "Có lỗi")
    );
  }
}

function* saveWorker(action: IDmLoaiThuChiActionTypes): any {
  let res: IBaseRespone;
  const payload = action.payload as IDmLoaiThuChi;
  if (payload.id_thu_chi > 0) {
    res = yield call(loaiThuChiApi.Update, payload);
  } else {
    res = yield call(loaiThuChiApi.Insert, payload);
  }
  if (res) {
    if (res.is_success) {
      yield put(rootActions.category.loaiThuChi.SAVE_SUCCESS(res.data));
    } else {
      yield put(
        rootActions.category.loaiThuChi.SAVE_ERROR(res.message ?? "Có lỗi")
      );
    }
  }
}

function* deleteWorker(action: IDmLoaiThuChiActionTypes): any {
  const res: IBaseRespone = yield call(
    loaiThuChiApi.Delete,
    action.payload as number
  );
  if (res.is_success) {
    yield put(rootActions.category.loaiThuChi.DELETE_SUCCESS(res.data));
  } else {
    yield put(
      rootActions.category.loaiThuChi.DELETE_ERROR(res.message ?? "Có lỗi")
    );
  }
}

function* deleteManyWorker(action: IDmLoaiThuChiActionTypes): any {
  const res: number = yield call(
    loaiThuChiApi.DeleteMany,
    action.payload as number[]
  );
  if (res > 0) {
    yield put(rootActions.category.loaiThuChi.DELETE_MANY_SUCCESS(undefined));
  } else {
    yield put(rootActions.category.loaiThuChi.DELETE_MANY_ERROR("Có lỗi"));
  }
}
